import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Card from '../common/Card';

export interface SettingsGroupProps {
  title?: string;
  children: React.ReactNode;
}

export const SettingsGroup: React.FC<SettingsGroupProps> = ({ title, children }) => {
  return (
    <View style={styles.groupContainer}>
      {title && <Text style={styles.groupTitle}>{title}</Text>}
      <Card style={styles.groupCard}>
        {children}
      </Card>
    </View>
  );
};

export const SettingsDivider: React.FC = () => {
  return <View style={styles.divider} />;
};

const styles = StyleSheet.create({
  groupContainer: {
    marginBottom: 25,
  },
  groupTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#666',
    marginBottom: 8,
    marginLeft: 5,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  groupCard: {
    paddingVertical: 0,
    paddingHorizontal: 0,
    overflow: 'hidden', // Ensure children don't overflow rounded corners
  },
  divider: {
    height: 1,
    backgroundColor: '#f0f0f0',
    marginLeft: 70, // Align with text start (icon width + margins)
  },
});

export default SettingsGroup;
